export class DownloadxmlShowmessage {
    public dateFormat : string;
    public poCreation : string
    constructor(dateFormat : string,
                poCreation : string
                ){
                    this.dateFormat=dateFormat;
                    this.poCreation=poCreation;
    }
}
